// extracted by mini-css-extract-plugin
module.exports = {"content":"Instructions_content__1CqQQ","title":"Instructions_title__2sF_v","block":"Instructions_block__XkZiB","fileItem":"Instructions_fileItem__NzKqn"};